import React from 'react';
import T from 'prop-types';
import cx from 'classnames';

const ConsensusSourceText = ({ className }) => (
  <p className={cx('consensus-source-text', className)}>
    Consensus source: Visible Alpha
  </p>
);

ConsensusSourceText.propTypes = {
  className: T.string,
};

export default ConsensusSourceText;
